import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useParams } from 'react-router';

import { apiClient } from '../api-client.ts';
import type { ReceiptDto } from '../types';

export const useMarkReceiptProcessed = (receiptId: string) => {
  const { projectId } = useParams();

  const queryClient = useQueryClient();

  return useMutation<ReceiptDto, Error>({
    mutationFn: () =>
      apiClient.put(`/v1/projects/${projectId}/receipts/${receiptId}/mark-processed`, {}),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['receipts', projectId] });
      queryClient.invalidateQueries({ queryKey: ['receipt'] });
    },
  });
};
